import { BaseSetting } from './base-setting.model';
import { KeyValuePair } from './key-value-pair.model';

export class GlobalSettingDao extends BaseSetting {
  constructor(settings: KeyValuePair[]) {
    super(settings);

    this.basGrouping = !!+this.getValue<string>('BasGruppierung', '0');
    this.basGruppenAuswaehlbar = !!+this.getValue<string>('BasGruppenAuswaehlbar', '0');
    this.absenzErfassenAktiv = !!+this.getValue<string>('AbsenzErfassenAktiv', '1');
    this.adPrForAllUsers = !!+this.getValue<string>('AdPrForAllUsers', '1');
    this.internErfassenAktiv = !!+this.getValue<string>('InternErfassenAktiv', '1');
    this.qrScannerAktiv = !!+this.getValue<string>('QrScannerAktiv', '1');
  }

  basGrouping: boolean;
  basGruppenAuswaehlbar: boolean;
  absenzErfassenAktiv: boolean;
  adPrForAllUsers: boolean;
  internErfassenAktiv: boolean;
  qrScannerAktiv: boolean;
}
